<template>

  <div class="flex flex-col bg-brand-gray font-sans text-white w-full h-full">
<!--    <div v-if="useReportBug().hasError">-->
<!--      {{useReportBug().errorMessage}}-->
<!--    </div>-->

    <div v-if="useReportBug().hasError.value" class="bg-red-500 px-4 py-2 flex items-center justify-between gap-4">

      <div class="flex gap-4 items-center">
        {{useReportBug().errorMessage}}
        <div class="cursor-pointer border border-white rounded-full px-2" @click="reportBug">Report bug</div>

        <UModal v-model="reportBugModalOpen">
          <div class="p-4">
            <div class="flex items-center justify-end">
              <UIcon name="i-lucide-x" dynamic class="text-lg mb-4 cursor-pointer" @click="reportBugModalOpen = false" />
            </div>

            Merci pour de nous avons informé du problème survenu. Nous nous excusons du désagrément et vous recontacterons quand l'erreur sera corrigée.

          </div>
        </UModal>

      </div>


        <UIcon @click="useReportBug().reset()" dynamic name="i-lucide-x"></UIcon>
    </div>
    <Header></Header>
    <UProgress :ui="{progress:{rounded:'rounded-0'}}" v-if="useSuivi().loading || useSuivi().loadingList" animation="carousel"/>
  <div class="flex flex-1 overflow-y-auto">

    <div class="w-[75px] px-4 py-5 hidden md:flex flex-col items-center text-center sticky top-0 border-r border-white">
      <NuxtLink to="/">
        <img src="~/assets/images/logo-o.svg" alt="Logo NOVA">
      </NuxtLink>
      <div class="mt-auto text-xs">
          NOVA
          Groupe
          2025
      </div>
    </div>


    <div class="flex-1 max-w-full md:max-w-[calc(100%-75px)]"> <!-- max-w-[calc(100%-75px)] = Workaround to avoid flex box destroying template -->
      <NuxtPage/>
    </div>
  </div>
        <UNotifications />

  </div>

  <!--  <div class="flex font-sans bg-brand-gray min-h-dvh text-white">-->

<!--    <div class="flex flex-col grow">-->
<!--      <Header></Header>-->
<!--      <div class="grow">-->
<!--&lt;!&ndash;        &ndash;&gt;-->
<!--        <NuxtPage/>-->
<!--&lt;!&ndash;        <UNotifications :ui="{width:'sm:w-[40rem]'}"/>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--    <UNotifications />-->

<!--  </div>-->
</template>

<script setup lang="ts">
import {useSuivi} from "~/store/suivi";
import {useReportBug} from "~/composables/reportBug";

const reportBugModalOpen = ref(false)
const reportBug = async () => {
  await useReportBug().reportBug()
  reportBugModalOpen.value = true

}
</script>
